export default "{version}"
